import { Fragment } from 'react';
import ArrowIosLeft from '@crehana/icons/outline/ArrowIosLeft';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors } from '@crehana/ui';
import cn from 'classnames';
import { useTranslation } from "../../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Submenu = function Submenu(_ref) {
  var title = _ref.title,
    onBack = _ref.onBack,
    options = _ref.options,
    selectedValue = _ref.selectedValue,
    onSelect = _ref.onSelect;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs("button", {
      type: "button",
      className: "bg-transparent focus:outline-none w-full flex items-center h-56",
      onClick: onBack,
      "aria-label": t('BACK_LABEL'),
      children: [/*#__PURE__*/_jsx(ArrowIosLeft, {
        size: 16,
        color: colors.secondaryMain
      }), /*#__PURE__*/_jsx("span", {
        className: "font-button text-base-main ml-8",
        children: title
      })]
    }), options.map(function (option) {
      return /*#__PURE__*/_jsx("button", {
        type: "button",
        className: cn('bg-transparent focus:outline-none w-full flex items-center h-56', option.value === selectedValue ? 'font-subtitle3 text-secondary-light' : 'font-body3 text-base-main'),
        onClick: function onClick() {
          onSelect(option);
        },
        children: option.label
      }, "mobile-option-".concat(title, "-").concat(option.value));
    })]
  });
};
export default Submenu;